import { useEffect, useState } from "react";
import React from 'react';
import Sidebar from "../sidebar";
import Navbar from "../navbar";
import axios from '../../api/axios';
import { useNavigate } from 'react-router-dom';
import Modal from './modal';
import EarningsModal from './takeEarningsModal';
import AddToCash from "./addToCash";
import { PiCashRegisterLight, PiHandDeposit } from "react-icons/pi";
import { GiPayMoney } from "react-icons/gi";
import { GrCafeteria } from "react-icons/gr";
import logo from '../../assets/images/SHTATO LOGO.jpg'
import { Calendar } from 'lucide-react';


const RESERVATIONS_URL = '/api/reservation';
const EARNINGS_URL = '/api/earnings/by-date';
const ITEMS_URL = '/api/table/items';

const Dashboard = () => {
  const [reservations, setReservations] = useState([]);
  const [isDayStarted, setIsDayStarted] = useState(false);
  const [earnings, setEarnings] = useState({
    totalEarnings: 0,
    earningsByZone: { salon: 0, rooftop: 0 }
  });
  const [bottomOfCash, setBottomOfCash] = useState(0);
  const [treasuryOutTotal, setTreasuryOutTotal] = useState(0);
  const [modalVisible, setModalVisible] = useState(false);
  const [earningsModalVisible, setEarningsModalVisible] = useState(false);
  const [treasuryOutModalVisible, setTreasuryOutModalVisible] = useState(false);
  const [treasuryOutAmount, setTreasuryOutAmount] = useState('');
  const [treasuryOutDescription, setTreasuryOutDescription] = useState('');
  const [caisse, setCaisse] = useState(0);
  const [addToCashVisible, setAddToCasModalVisible] = useState(false);
  const navigate = useNavigate();
  const [salesData, setSalesData] = useState(null);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).split('/').join('-')
  );

  const formatDateForInput = (dateString) => {
    const [day, month, year] = dateString.split('-');
    return `${year}-${month}-${day}`;
  };

  const handleDateChange = (e) => {
    const inputDate = e.target.value;
    const [year, month, day] = inputDate.split('-');
    setSelectedDate(`${day}-${month}-${year}`);
  };

  const fetchItems = async (date) => {
    try {
      const response = await axios.get(`${ITEMS_URL}?date=${date}`);
      setSalesData(response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching items:', error);
      return null;
    }
  };

  useEffect(() => {
    setCaisse(bottomOfCash + earnings.totalEarnings - treasuryOutTotal);
  }, [bottomOfCash, earnings.totalEarnings, treasuryOutTotal]);

  const handleDayToggle = async () => {
    if (isDayStarted) {
      const data = await fetchItems(selectedDate);
      if (data) {
        printEndDayReceipt(data);
      }
      setModalVisible(true);
    } else {
      setIsDayStarted(true);
      localStorage.setItem("isDayStarted", true);
      localStorage.setItem("bottomOfCash", bottomOfCash);
      localStorage.setItem("treasuryOutTotal", treasuryOutTotal);
    }
  };

  const printEndDayReceipt = (data) => {
    if (!data || !data.summary) {
      console.error('Invalid sales data');
      return;
    }

    const receiptWindow = window.open('', '_blank', 'width=400,height=600');
    const date = new Date();

    const renderItemsSection = (items = {}) => {
      return Object.entries(items).map(([itemName, details]) => `
        <div class="item">
          <span class="item-name">${itemName}</span>
          <div class="item-details">
            <span class="item-quantity">${details.quantity}x</span>
            <span class="item-total">${formatCurrency(details.totalSales)}</span>
          </div>
        </div>
      `).join('');
    };

    const renderLocationSection = (locationData, locationName) => `
      <div class="section">
        <div class="location-header">
          <div class="location-indicator"></div>
          <span class="location-name">${locationName}</span>
        </div>
        
        <div class="location-summary">
          <div class="summary-row">
            <span>Tables Served</span>
            <span class="value">${locationData.tablesServed}</span>
          </div>
          <div class="summary-row">
            <span>Total Sales</span>
            <span class="value highlight">${formatCurrency(locationData.totalSales)}</span>
          </div>
        </div>
        
        ${locationData.totalSales > 0 ? `
          <div class="items-section">
            <div class="section-title">Items Sold</div>
            <div class="items-container">
              ${renderItemsSection(locationData.items)}
            </div>
          </div>
        ` : '<div class="no-sales">No sales recorded</div>'}
      </div>
    `;

    receiptWindow.document.write(`
      <html>
        <head>
          <title>End Day Report</title>
          <style>
            @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
            
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }

            body {
              font-family: 'Inter', sans-serif;
              background: #f5f5f5;
              color: #1a1a1a;
              line-height: 1.5;
              padding: 2rem;
            }

            .receipt {
              max-width: 420px;
              margin: 0 auto;
              background: white;
              border-radius: 16px;
              box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
              padding: 2rem;
            }

            .header {
              text-align: center;
              margin-bottom: 2rem;
              padding-bottom: 1.5rem;
              border-bottom: 1px solid #f0f0f0;
            }

            .logo {
              width: 80px;
              height: auto;
              margin-bottom: 1rem;
            }

            .title {
              font-size: 1.5rem;
              font-weight: 700;
              color: #610c63;
              margin-bottom: 0.5rem;
            }

            .date {
              font-size: 0.875rem;
              color: #666;
            }

            .section {
              margin-bottom: 2rem;
              padding: 1.5rem;
              background: #fafafa;
              border-radius: 12px;
            }

            .location-header {
              display: flex;
              align-items: center;
              gap: 0.75rem;
              margin-bottom: 1rem;
            }

            .location-indicator {
              width: 8px;
              height: 8px;
              background: #610c63;
              border-radius: 50%;
            }

            .location-name {
              font-size: 1.25rem;
              font-weight: 600;
              color: #610c63;
            }

            .location-summary {
              background: white;
              padding: 1.25rem;
              border-radius: 8px;
              margin-bottom: 1.5rem;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
            }

            .summary-row {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 0.5rem 0;
            }

            .summary-row span {
              font-size: 0.875rem;
              color: #666;
            }

            .summary-row .value {
              font-weight: 600;
              color: #1a1a1a;
            }

            .summary-row .highlight {
              color: #610c63;
              font-weight: 700;
            }

            .section-title {
              font-size: 0.75rem;
              font-weight: 600;
              color: #666;
              margin-bottom: 0.75rem;
              text-transform: uppercase;
              letter-spacing: 0.75px;
            }

            .items-container, .categories-container {
              background: white;
              border-radius: 8px;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
              overflow: hidden;
            }

            .item, .category {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 0.875rem 1.25rem;
              border-bottom: 1px solid #f0f0f0;
              transition: background-color 0.2s ease;
            }

            .item:hover, .category:hover {
              background-color: #fafafa;
            }

            .item:last-child, .category:last-child {
              border-bottom: none;
            }

            .item-name, .category-name {
              font-size: 0.875rem;
              color: #1a1a1a;
            }

            .item-details, .category-details {
              display: flex;
              align-items: center;
              gap: 1.25rem;
            }

            .item-quantity, .category-quantity {
              font-size: 0.875rem;
              color: #666;
              min-width: 3rem;
              text-align: right;
            }

            .item-total, .category-total {
              font-size: 0.875rem;
              font-weight: 600;
              color: #1a1a1a;
              min-width: 5rem;
              text-align: right;
            }

            .no-sales {
              text-align: center;
              padding: 1.25rem;
              color: #666;
              font-size: 0.875rem;
              background: white;
              border-radius: 8px;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
            }

            .summary {
              margin-top: 2rem;
              padding: 1.5rem;
              background: #610c63;
              color: white;
              border-radius: 12px;
              box-shadow: 0 4px 16px rgba(97, 12, 99, 0.2);
            }

            .summary .summary-row {
              padding: 0.875rem 0;
              border-bottom: 1px solid rgba(255, 255, 255, 0.1);
            }

            .summary .summary-row:last-child {
              border-bottom: none;
            }

            .summary .summary-row span {
              color: rgba(255, 255, 255, 0.8);
            }

            .summary .summary-row .value {
              color: white;
              font-weight: 700;
            }

            .footer {
              text-align: center;
              margin-top: 2rem;
              padding-top: 1.5rem;
              border-top: 1px solid #f0f0f0;
              color: #666;
              font-size: 0.875rem;
            }

            .footer p:first-child {
              margin-bottom: 0.5rem;
            }

            @media print {
              body {
                background: white;
                padding: 0;
              }
              
              .receipt {
                box-shadow: none;
                max-width: none;
                padding: 1rem;
              }

              .items-container, .categories-container, .location-summary, .no-sales {
                box-shadow: none;
              }

              .summary {
                box-shadow: none;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
              }
            }
          </style>
        </head>
        <body>
          <div class="receipt">
            <div class="header">
              <img src="${logo}" alt="Logo" class="logo">
              <div class="title">End Day Report</div>
              <div class="date">${date.toLocaleDateString()} ${date.toLocaleTimeString()}</div>
            </div>

            ${renderLocationSection(data.summary.byLocation.rooftop, 'Rooftop')}
            ${renderLocationSection(data.summary.byLocation.salon, 'Salon')}

            <div class="summary">
              <div class="summary-row">
                <span>Total Tables Served</span>
                <span class="value">${data.summary.totals.tablesServed}</span>
              </div>
              <div class="summary-row">
                <span>Total Sales</span>
                <span class="value">${formatCurrency(data.summary.totals.totalSales)}</span>
              </div>
              <div class="summary-row">
                <span>Bottom of Cash</span>
                <span class="value">${formatCurrency(bottomOfCash)}</span>
              </div>
              <div class="summary-row">
                <span>Treasury Out</span>
                <span class="value">${formatCurrency(treasuryOutTotal)}</span>
              </div>
              <div class="summary-row">
                <span>Final Cash</span>
                <span class="value">${formatCurrency(caisse)}</span>
              </div>
            </div>

            <div class="footer">
              <p>Powered by Gentium</p>
            </div>
          </div>
          
          <script>
            window.onload = function() {
              window.print();
            }
          </script>
        </body>
      </html>
    `);

    receiptWindow.document.close();
  };

  const addAmountToBottomOfCash = (amount) => {
    const newAmount = bottomOfCash + amount;
    setBottomOfCash(newAmount);
    localStorage.setItem("bottomOfCash", newAmount);
  };

  const handleModalSubmit = (amount) => {
    addAmountToBottomOfCash(amount);
  };

  const handleBottomOfCashClick = () => {
    setAddToCasModalVisible(true);
  };

  const handleTreasuryOutClick = () => {
    setTreasuryOutModalVisible(true);
  };

  const handleTreasuryOutSubmit = () => {
    const amount = parseFloat(treasuryOutAmount);
    if (isNaN(amount) || amount <= 0) {
      alert("Please enter a valid amount");
      return;
    }

    const newTotal = treasuryOutTotal + amount;
    setTreasuryOutTotal(newTotal);
    localStorage.setItem("treasuryOutTotal", newTotal);

    printTreasuryOutReceipt(amount, treasuryOutDescription);

    setTreasuryOutAmount('');
    setTreasuryOutDescription('');
    setTreasuryOutModalVisible(false);
  };

  const printTreasuryOutReceipt = (amount, description) => {
    const receiptWindow = window.open('', '_blank', 'width=300,height=600');
    const date = new Date();
  
    receiptWindow.document.write(`
      <html>
        <head>
          <title>Trésorerie Out</title>
          <style>
            body {
              margin: 0;
              padding: 0;
              height: 100vh;
              background: white;
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .receipt {
              width: 220px; /* Width for 58mm printer */
              padding: 20px; /* Adjusted padding */
              background: transparent;
              font-family: Arial, sans-serif; /* Set default font */
            }
            .header {
              text-align: center;
              margin-bottom: 1.5rem;
              padding-bottom: 1rem;
              border-bottom: 1px solid #f0f0f0;
            }
            .logo {
              width: 70px; /* Adjust logo size */
              height: auto;
              margin-bottom: 1rem;
            }
            .team, .timestamp {
              text-align: center;
              font-size: 12px; /* Adjusted font size */
              margin: 10px 0;
            }
            .title {
              text-align: center;
              font-size: 14px; /* Adjusted font size */
              font-weight: bold;
              margin: 10px 0 20px 0;
            }
            .details {
              display: grid;
              grid-template-columns: auto auto;
              gap: 5px; /* Adjusted gap */
              margin: 10px 0; /* Adjusted margin */
              font-size: 12px; /* Adjusted font size */
            }
            .label {
              font-weight: bold;
            }
            .value {
              text-align: right;
            }
          </style>
        </head>
        <body>
          <div class="receipt">
            <div class="header">
              <img src="${logo}" alt="Logo" class="logo">
            </div>
            
            <div class="team">Servi par Shtatto Team</div>
            
            <div class="title">TRESORERIE OUT</div>
            
            <div class="details">
              <div class="label">MONTANT</div>
              <div class="value">${amount.toLocaleString('fr-FR')} DH</div>
              <div class="label">RAISON</div>
              <div class="value">${description}</div>
            </div>
            
            <div class="timestamp">${date.toLocaleString('fr-FR')}</div>
          </div>
          
          <script>
            window.onload = function() {
              window.print();
            }
          </script>
        </body>
      </html>
    `);
  
    receiptWindow.document.close();
  };  

  const closeEarningsModal = () => {
    setEarningsModalVisible(false);
  };

  const closeTreasuryOutModal = () => {
    setTreasuryOutModalVisible(false);
  };

  const closeModal = () => {
    setModalVisible(false);
    localStorage.removeItem("token");
    localStorage.removeItem("isDayStarted");
    localStorage.removeItem("bottomOfCash");
    localStorage.removeItem("treasuryOutTotal");
    navigate('/login');
  };

  const fetchReservations = async () => {
    try {
      const date = new Date();
      const localDate = date.toLocaleDateString('fr-CA');
      const response = await axios.get(`${RESERVATIONS_URL}?date=${localDate}`);
      const sortedReservations = response.data.sort((a, b) => a.time - b.time);
      setReservations(sortedReservations);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchEarnings = async (date) => {
    try {
      const response = await axios.get(`${EARNINGS_URL}?date=${date}`);
      setEarnings(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('fr-MA', {
      style: 'currency',
      currency: 'MAD',
      maximumFractionDigits: 2
    }).format(amount);
  };

  const formatTime = (time) => {
    const hours = Math.floor(time);
    const minutes = (time % 1) * 60;
    const timeString = `${hours.toString().padStart(2, '0')}:${minutes === 0 ? '00' : '30'}`;
    return new Date(`2000-01-01T${timeString}`).toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  function formatDate(date) {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const isPastReservation = (reservation) => {
    const now = new Date();
    const currentTime = now.getHours() + now.getMinutes() / 60;
    return reservation.time < currentTime || reservation.arrived;
  };

  const futureReservations = reservations.filter(reservation => !isPastReservation(reservation));
  const arrivedReservations = reservations.filter(res => res.arrived === "arrived");
  const pastReservations = reservations.filter(isPastReservation);
  const noShowReservations = pastReservations.filter(res => res.arrived === "noshow" || !res.arrived);

  useEffect(() => {
    fetchEarnings(selectedDate);
    fetchItems(selectedDate);
    console.log(selectedDate);

  }, [selectedDate]);

  useEffect(() => {
    fetchReservations();
    fetchEarnings(selectedDate);
    fetchItems(selectedDate);
    const savedDayState = localStorage.getItem("isDayStarted");
    if (savedDayState !== null) {
      setIsDayStarted(savedDayState === "true");
    }
    const savedBottomOfCash = localStorage.getItem("bottomOfCash");
    if (savedBottomOfCash !== null) {
      setBottomOfCash(Number(savedBottomOfCash));
    }
    const savedTreasuryOutTotal = localStorage.getItem("treasuryOutTotal");
    if (savedTreasuryOutTotal !== null) {
      setTreasuryOutTotal(Number(savedTreasuryOutTotal));
    }
  }, []);

  if (!isDayStarted) {
    return (
      <div className="fixed inset-0 flex items-center justify-center">
        <div className="bg-white rounded-lg w-full max-w-xl shadow-lg">
          <div className="border-b border-gray-200 p-6">
            <h1 className="text-3xl font-bold text-[#610c63] text-center">Start New Day!</h1>
          </div>

          <div className="p-8">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="text-center p-6 bg-purple-100 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
                <p className="text-sm text-gray-500 mb-2">Bottom of Cash</p>
                <div className="flex items-center justify-center">
                  <input
                    type="number"
                    value={bottomOfCash}
                    onChange={(e) => setBottomOfCash(Number(e.target.value))}
                    className="text-4xl font-bold text-[#610c63] bg-transparent text-center w-32 focus:outline-none focus:ring-2 focus:ring-[#610c63] focus:ring-opacity-50 rounded-md"
                  />
                  <span className="text-2xl font-bold text-[#610c63] ml-1">MAD</span>
                </div>
              </div>

              <div className="text-center p-6 bg-purple-100 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
                <p className="text-sm text-gray-500 mb-2">Total Reservations</p>
                <p className="text-4xl font-bold text-[#610c63]">{reservations.length}</p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
              <div className="text-center p-6 bg-green-100 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
                <p className="text-sm text-gray-500 mb-2">Arrived Guests</p>
                <p className="text-4xl font-bold text-green-600">{arrivedReservations.length}</p>
              </div>

              <div className="text-center p-6 bg-red-100 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
                <p className="text-sm text-gray-500 mb-2">No Shows</p>
                <p className="text-4xl font-bold text-red-600">{noShowReservations.length}</p>
              </div>
            </div>

            <div className="text-center mt-8">
              <button
                onClick={handleDayToggle}
                className="bg-[#610c63] text-white px-8 py-3 rounded-lg hover:bg-[#4a0a4c] transition-colors duration-300 text-lg font-medium w-full md:w-auto"
              >
                Start New Day
              </button>
              <p className="text-sm text-gray-500 mt-4">Click to begin a new day and view the dashboard</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex bg-[#F9F9F9]">
      <div className="fixed lg:relative lg:flex">
        <Sidebar />
      </div>
      <div className="flex-1">
        <Navbar />
        <div className="flex-1 ml-0 lg:ml-64 p-4">
          <div className="flex justify-between items-center mb-6">
            <div className="flex items-center gap-3">
              <h1 className="text-2xl font-bold">Dashboard Overview</h1>
              <div className="flex items-center p-2 rounded-lg shadow-sm">
                <Calendar className="text-gray-500 mr-2" size={18} />
                <input
                  type="date"
                  value={formatDateForInput(selectedDate)}
                  onChange={handleDateChange}
                  className="px-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#610c63] focus:border-[#610c63] transition duration-150 ease-in-out"
                />
              </div>
            </div>
            <button
              onClick={handleDayToggle}
              className="group relative bg-gradient-to-r from-[#610c63] to-[#4a0a4c] text-white px-8 py-3 rounded-lg shadow-md 
           hover:from-[#4a0a4c] hover:to-[#380839] hover:shadow-lg 
           transition-all duration-200 transform active:scale-95
           focus:outline-none focus:ring-2 focus:ring-[#610c63] focus:ring-opacity-50"
            >
              <div className="absolute inset-0 bg-black opacity-0 group-hover:opacity-10 rounded-lg transition-opacity"></div>
              <div className="flex items-center justify-center space-x-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                  />
                </svg>
                <span className="font-medium">End Day</span>
              </div>
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-gray-500">Total earnings</p>
                  <p className="text-2xl font-bold text-[#610c63]">{formatCurrency(earnings.totalEarnings)}</p>
                </div>
                <div className="bg-purple-100 p-3 rounded-full">
                  <GrCafeteria size={24} />
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm cursor-pointer hover:bg-gray-50" onClick={handleTreasuryOutClick}>
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-gray-500">Tresorie out</p>
                  <p className="text-2xl font-bold text-[#610c63]">{formatCurrency(treasuryOutTotal)}</p>
                </div>
                <div className="bg-purple-100 p-3 rounded-full">
                  <PiHandDeposit size={28} />
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm cursor-pointer" onClick={handleBottomOfCashClick}>
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-gray-500">Bottom of cash</p>
                  <p className="text-2xl font-bold text-[#610c63]">{formatCurrency(bottomOfCash)}</p>
                </div>
                <div className="bg-purple-100 p-3 rounded-full">
                  <GiPayMoney size={28} />
                </div>
              </div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm">
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm text-gray-500">Caisse</p>
                  <p className="text-2xl font-bold text-[#610c63]">{formatCurrency(caisse)}</p>
                </div>
                <div className="bg-purple-100 p-3 rounded-full">
                  <PiCashRegisterLight size={28} />
                </div>
              </div>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-sm p-6">
            <h2 className="text-lg font-semibold mb-4">Upcoming Reservations</h2>
            <div className="overflow-x-auto">
              <table className="min-w-full">
                <thead>
                  <tr className="border-b">
                    <th className="text-left py-3 px-4 text-sm font-medium text-gray-500">Name</th>
                    <th className="text-left py-3 px-4 text-sm font-medium text-gray-500">Time</th>
                    <th className="text-left py-3 px-4 text-sm font-medium text-gray-500">Date</th>
                    <th className="text-left py-3 px-4 text-sm font-medium text-gray-500">Zone</th>
                  </tr>
                </thead>
                <tbody>
                  {futureReservations.map((reservation) => (
                    <tr key={reservation.id} className="border-b">
                      <td className="py-3 px-4 text-sm">{reservation.name}</td>
                      <td className="py-3 px-4 text-sm">{formatTime(reservation.time)}</td>
                      <td className="py-3 px-4 text-sm">{formatDate(new Date(reservation.date))}</td>
                      <td className="py-3 px-4">
                        <span className="px-2 py-1 text-xs font-medium rounded-full bg-purple-100 text-purple-800">
                          {reservation.zone === "rooftop" ? "Rooftop" : "Salon"}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          {modalVisible && (
            <Modal
              onClose={closeModal}
              totalEarnings={earnings.totalEarnings}
              totalReservations={reservations.length}
              arrivedGuests={arrivedReservations.length}
              noShows={noShowReservations.length}
            />
          )}
        </div>
        {earningsModalVisible && (
          <EarningsModal
            onClose={closeEarningsModal}
            totalEarnings={formatCurrency(earnings.totalEarnings)}
            earningsByZone={earnings.earningsByZone}
          />
        )}
        {treasuryOutModalVisible && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg w-full max-w-md p-6">
              <h2 className="text-xl font-bold text-[#610c63] mb-6">Treasury Out</h2>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Amount (MAD)</label>
                <input
                  type="number"
                  value={treasuryOutAmount}
                  onChange={(e) => setTreasuryOutAmount(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#610c63] focus:border-transparent"
                  placeholder="Enter amount"
                />
              </div>
              <div className="mb-6">
                <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                <textarea
                  value={treasuryOutDescription}
                  onChange={(e) => setTreasuryOutDescription(e.target.value)}
                  className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#610c63] focus:border-transparent"
                  rows="3"
                  placeholder="Enter description"
                ></textarea>
              </div>
              <div className="flex justify-end space-x-3">
                <button
                  onClick={closeTreasuryOutModal}
                  className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors"
                >
                  Cancel
                </button>
                <button
                  onClick={handleTreasuryOutSubmit}
                  className="px-4 py-2 bg-[#610c63] text-white rounded-md hover:bg-[#4a0a4c] transition-colors"
                >
                  Submit & Print Receipt
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
      <AddToCash
        isVisible={addToCashVisible}
        onClose={() => setAddToCasModalVisible(false)}
        onSubmit={handleModalSubmit}
      />
    </div>
  );
};

export default Dashboard;